import React from 'react'
import {Flex} from "./layout"
import Plus from "./_Plus"
import Superface from '../Superface'

export default class MaterialsKinds extends React.Component{

    constructor(props){
        super(props)
        this.handleClick = this.handleClick.bind(this)
        this.handleResize = this.handleResize.bind(this)
        
    }


    componentWillMount(){
        this.setState({
            mounted : false
        })
        window.addEventListener('resize', this.handleResize )
    }

    handleResize(){
        this.setState({ ...this.state })
    }

    componentDidMount(){
        this.timeoutMount = window.setTimeout( () => {
            // alert()
            this.setState({
                mounted : true
            })
        }, 1200)
    }

    componentWillUnmount(){
        window.clearTimeout( this.timeoutMount )
    }

    handleClick(slug){
        Superface.toggleFilter(slug, this.props.type)
    }

    renderControl(){
        return this.props.filters.map( (filter, i) => {
            return (
                <Flex 
                    className='filter' 
                    direction="column" 
                    align="center" 
                    justify="flex-end" 
                    key={'filter' + i}
                    style={{pointerEvents : 'all'}}
                    onMouseDown={ (e) => { e.preventDefault(); this.handleClick(filter.slug) }}
                    >
                    <Plus selected={ filter.active ? true : false} />
                    <div>
                        <p className={( filter.active ? '' : ' active' )}>
                            <span>{Superface.field(filter, 'name')}</span>
                        </p>
                    </div>
                    <div>
                       &nbsp;&nbsp;
                    </div>
                </Flex>
            )
        })
    }


    render(){
        
        const style = {
            position : 'absolute',
            bottom : '0',
            width : '100%',
            justifyContent : 'center',
            pointerEvents : 'none',
            display : ( window.innerWidth < 900 ? 'none' : 'flex' )
        }
        
        return(
            <Flex id="filters" className={ this.state.mounted ? 'mounted' : ''} style={style}>
                
                {this.renderControl()}

            </Flex>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/_Filters.js